// frontend/src/components/mind-mesch/MindMeschNavbar.js

import React from 'react';
import { Link } from 'react-router-dom';

const MindMeschNavbar = () => {
  return (
    <nav className="mindmesch-navbar">
      <div className="logo">Mind Mesch</div>
      <ul className="nav-links">
        <li><Link to="/partner-api">Home</Link></li>
        <li><Link to="/partner-api/docs">Docs</Link></li>
        <li><Link to="/partner-api/help">Help</Link></li>
        <li><Link to="/partner-api/about">About</Link></li>
        <li><Link to="/partner-api/faq">FAQ</Link></li>
        <li><Link to="/partner-api/privacy">Privacy</Link></li>
        <li><Link to="/partner-api/terms">Terms</Link></li>
      </ul>
    </nav>
  );
};

export default MindMeschNavbar;
